import API from './apiClient';

export const sendContact = (formData) => API.post('/contact', formData);
export const fetchContacts = () => API.get('/contact');
